import ForgotPasswordCtrl from './controllers/forgotPasswordController.js';
var moduleName = 'forgotPassword';
angular.module(moduleName, []).controller('ForgotPasswordCtrl', ForgotPasswordCtrl);
export default moduleName;